var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button",on:{"click":_vm.getArea}},[_c('a-icon',{staticStyle:{"font-size":"18px"},attrs:{"type":"pushpin"}}),_c('div',[_vm._v(_vm._s(_vm.isGettingArea ? "结束拾取" : "获取面积"))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }